module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gcNiH"))).then(() => parcelRequire('3a9aZ'));